export function checkDuplicated(insertId: string) {
  if (sessionStorage.getItem(insertId)) {
    return true
  }

  sessionStorage.setItem(insertId, 'tracked')

  return false
}
